export const Endpoints: { [key: string]: string } = {
    MI_BAHIA: process.env.REACT_APP_MIBAHIA_URL || "",
    AUTENTICA: process.env.REACT_APP_AUTENTICA_URL || "",
};

/**
 * Joins a base URL and a path, ensuring there are no duplicate slashes and that the base URL is valid.
 * @param base str: schema://host:port/
 * @param path str: /path/to/resource
 * @returns str: schema://host:port/path/to/resource
 */
export function joinUrl(base: string, path: string): string {
  // 1. Ensure base ends with a slash
  const baseWithSlash = base.endsWith('/') ? base : `${base}/`;
  // 2. Remove leading slash from path
  const cleanPath = path.replace(/^\/+/, '');
  
  try {
    return new URL(cleanPath, baseWithSlash).href;
  } catch (e) {
    console.error("Invalid Base URL provided to joinUrl:", base);
    return `${baseWithSlash}${cleanPath}`; // Fallback to manual join
  }
};